

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const AllQuestions = () => {
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [questionsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');

  const getdata = async (page = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API}/questions/getquestions`, {
        params: { page, limit: questionsPerPage },
      });

      setQuestions(response.data.questions);
      setTotalPages(response.data.totalPages);
      setCurrentPage(response.data.currentPage);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching questions:', err);
      setError('Failed to fetch questions.');
      setLoading(false);
    }
  };

  useEffect(() => {
    getdata(1);
  }, []);

  const paginate = (pageNumber) => {
    getdata(pageNumber);
  };

  const filteredQuestions = questions.filter((q) =>
    q.question.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ padding: '30px', fontFamily: 'Segoe UI, sans-serif' }}>
      <h2 style={{ color: '#333', textAlign: 'center', marginBottom: '20px' }}>📝 All Questions</h2>

      {/* Search */}
      <input
        type="text"
        placeholder="🔍 Search Questions..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          marginBottom: '20px',
          padding: '10px',
          width: '100%',
          maxWidth: '400px',
          borderRadius: '8px',
          border: '1px solid #ccc',
          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          outlineColor: '#007bff',
          fontSize: '16px',
        }}
      />

      {loading && <p>Loading...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {filteredQuestions.length > 0 ? (
        <div style={{ overflowX: 'auto', maxHeight: '70vh', marginTop: '10px' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              backgroundColor: '#fff',
              boxShadow: '0 0 10px rgba(0,0,0,0.05)',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <thead style={{ backgroundColor: '#007bff', color: '#fff' }}>
              <tr>
                <th style={thStyle}>ID</th>
                <th style={thStyle}>Question</th>
                <th style={thStyle}>Option A</th>
                <th style={thStyle}>Option B</th>
                <th style={thStyle}>Option C</th>
                <th style={thStyle}>Option D</th>
                <th style={thStyle}>Correct</th>
              </tr>
            </thead>
            <tbody>
              {filteredQuestions.map((q, index) => (
                <tr key={q.id || index} style={index % 2 === 0 ? rowEven : rowOdd}>
                  <td style={tdStyle}>{q.id}</td>
                  <td style={tdStyle}>{q.question}</td>
                  <td style={tdStyle}>{q.option_a}</td>
                  <td style={tdStyle}>{q.option_b}</td>
                  <td style={tdStyle}>{q.option_c}</td>
                  <td style={tdStyle}>{q.option_d}</td>
                  <td style={tdStyle}>{q.correct_option}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        !loading && <p>No questions found.</p>
      )}

      {/* Pagination */}
      <div
        style={{
          marginTop: '25px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
        }}
      >
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          style={buttonStyle(currentPage === 1)}
        >
          ⬅ Previous
        </button>

        <span style={{ fontSize: '16px', color: '#444' }}>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </span>

        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={buttonStyle(currentPage === totalPages)}
        >
          Next ➡
        </button>
      </div>
    </div>
  );
};

export default AllQuestions;

// Reusable styles
const thStyle = {
  padding: '12px 15px',
  textAlign: 'left',
  fontWeight: '600',
  fontSize: '15px',
};

const tdStyle = {
  padding: '12px 15px',
  fontSize: '14px',
  color: '#333',
};

const rowEven = {
  backgroundColor: '#f9f9f9',
};

const rowOdd = {
  backgroundColor: '#fff',
};

const buttonStyle = (disabled) => ({
  padding: '10px 18px',
  backgroundColor: disabled ? '#ccc' : '#007bff',
  color: '#fff',
  border: 'none',
  borderRadius: '6px',
  cursor: disabled ? 'not-allowed' : 'pointer',
  fontSize: '15px',
  transition: 'all 0.3s ease',
  boxShadow: disabled ? 'none' : '0 2px 6px rgba(0,0,0,0.1)',
});
